import React from 'react';
import Grid from '@lendi-ui/grid';

import { FUNNEL_CONTAINER_GRID_OPTIONS } from '@funnels/constants';
import { BackButton } from '@funnels/ui-components';

import { BackButtonContainer, Container } from './index.style';

interface FunnelContainerProps {
  children: React.ReactNode;
  shouldHideBackButton?: boolean;
}

function FunnelContainer(props: FunnelContainerProps) {
  return (
    <Container role="main">
      <BackButtonContainer>{!props.shouldHideBackButton && <BackButton />}</BackButtonContainer>
      <Grid gutter="nil">
        <Grid.Unit {...FUNNEL_CONTAINER_GRID_OPTIONS}>{props.children}</Grid.Unit>
      </Grid>
    </Container>
  );
}

export default FunnelContainer;
